import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { selectLanguage, setLanguage } from 'features/users/usersSlice';

import { DropdownMenu } from 'ui/navigation/Dropdown/DropdownMenu';
import { useEffect } from 'react';


export const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const language = useAppSelector(selectLanguage);
  const dispatch = useAppDispatch();

  const getLanguageFlag = (lang: string) => {
    switch(lang) {
      case 'en':
        return '🇺🇸';
      case 'ru':
        return '🇷🇺';
      default:
        return '🏳️';
    }
  }

  const setLanguageHandler = (lang: string) => {
    i18n.changeLanguage(lang);
    dispatch(setLanguage(lang));
  }

  useEffect(() => {
    if(language && i18n.language !== language) {
      i18n.changeLanguage(language);
    }
  }, [language, i18n]);

  return (
    <li className="nav-item dropdown">
      <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
        {getLanguageFlag(language as string)}
      </a>
      <DropdownMenu>
        <li><a className="dropdown-item" href="#" onClick={() => setLanguageHandler('en')}>🇺🇸 English</a></li>
        <li><a className="dropdown-item" href="#" onClick={() => setLanguageHandler('ru')}>🇷🇺 Русский</a></li>
      </DropdownMenu>
    </li>
  );
}